/* Hello couleur — filtrage et tri client-side d'une grille collection.
   Port verbatim du <script> inline des mockups 03*_collection_*.html lignes
   875-1007 (avec mise à jour des compteurs ajoutée pour Shopify). Le HTML doit
   contenir :
   - .filters (sidebar) avec <input type="checkbox" data-filter="format|theme|stock" value="...">
     et un range double #price-min / #price-max + #range-fill + #price-min-label / #price-max-label
   - .products-grid > a.product-card[data-format][data-themes][data-price][data-stock][data-name][data-bestseller][data-new]
   - .toolbar avec #product-count-toolbar et #sort
   - bouton #filter-reset */
(function () {
  var grid = document.querySelector('.products-grid');
  if (!grid) return;
  var cards = Array.from(grid.querySelectorAll('.product-card'));
  var counter = document.getElementById('product-count');
  var counterToolbar = document.getElementById('product-count-toolbar');
  var resetBtn = document.getElementById('filter-reset');
  var sortSelect = document.getElementById('sort');
  var priceMinInput = document.getElementById('price-min');
  var priceMaxInput = document.getElementById('price-max');
  var priceMinLabel = document.getElementById('price-min-label');
  var priceMaxLabel = document.getElementById('price-max-label');
  var rangeFill = document.getElementById('range-fill');
  var priceMin = parseFloat(priceMinInput ? priceMinInput.dataset.min || 0 : 0);
  var priceMax = parseFloat(priceMinInput ? priceMinInput.dataset.max || 100 : 100);

  function updateRangeFill() {
    if (!priceMinInput || !priceMaxInput || !rangeFill) return;
    var minVal = parseFloat(priceMinInput.value);
    var maxVal = parseFloat(priceMaxInput.value);
    if (minVal > maxVal) {
      priceMinInput.value = maxVal;
      priceMaxInput.value = minVal;
    }
    var range = priceMax - priceMin;
    var minPct = ((parseFloat(priceMinInput.value) - priceMin) / range) * 100;
    var maxPct = ((parseFloat(priceMaxInput.value) - priceMin) / range) * 100;
    rangeFill.style.left = minPct + '%';
    rangeFill.style.right = (100 - maxPct) + '%';
    if (priceMinLabel) priceMinLabel.textContent = parseFloat(priceMinInput.value).toFixed(2).replace('.', ',') + ' €';
    if (priceMaxLabel) priceMaxLabel.textContent = parseFloat(priceMaxInput.value).toFixed(2).replace('.', ',') + ' €';
  }

  var originalOrder = cards.map(function (c, i) { return { el: c, idx: i }; });

  function getActiveFilters(group) {
    return Array.from(document.querySelectorAll('input[data-filter="' + group + '"]:checked')).map(function (el) { return el.value; });
  }

  function applyFilters() {
    var formats = getActiveFilters('format');
    var themes = getActiveFilters('theme');
    var stockOnly = document.querySelector('input[data-filter="stock"]:checked');
    var minPriceVal = priceMinInput ? parseFloat(priceMinInput.value) : 0;
    var maxPriceVal = priceMaxInput ? parseFloat(priceMaxInput.value) : Infinity;

    var visibleCount = 0;
    cards.forEach(function (card) {
      var cardFmt = card.dataset.format;
      var cardThemes = (card.dataset.themes || '').split(',').filter(Boolean);
      var cardPrice = parseFloat(card.dataset.price);
      var cardStock = card.dataset.stock;

      var visible = true;
      if (formats.length && formats.indexOf(cardFmt) === -1) visible = false;
      if (themes.length && !themes.some(function (t) { return cardThemes.indexOf(t) !== -1; })) visible = false;
      if (stockOnly && cardStock !== 'in') visible = false;
      if (cardPrice < minPriceVal || cardPrice > maxPriceVal) visible = false;

      card.classList.toggle('hidden', !visible);
      if (visible) visibleCount++;
    });

    if (counter) counter.textContent = visibleCount;
    if (counterToolbar) counterToolbar.textContent = visibleCount;

    var empty = grid.querySelector('.empty-state');
    if (visibleCount === 0) {
      if (!empty) {
        empty = document.createElement('div');
        empty.className = 'empty-state';
        empty.innerHTML = '<div class="empty-state__icon">🔍</div><h3>Aucun produit ne correspond à vos filtres</h3><p>Modifiez ou retirez quelques filtres pour voir plus de résultats.</p>';
        grid.appendChild(empty);
      }
    } else if (empty) {
      empty.remove();
    }
  }

  function applySort() {
    if (!sortSelect) return;
    var val = sortSelect.value;
    var visibleCards = cards.filter(function (c) { return !c.classList.contains('hidden'); });
    var sorted;
    if (val === 'price-asc') {
      sorted = visibleCards.slice().sort(function (a, b) { return parseFloat(a.dataset.price) - parseFloat(b.dataset.price); });
    } else if (val === 'price-desc') {
      sorted = visibleCards.slice().sort(function (a, b) { return parseFloat(b.dataset.price) - parseFloat(a.dataset.price); });
    } else if (val === 'name') {
      sorted = visibleCards.slice().sort(function (a, b) { return a.dataset.name.localeCompare(b.dataset.name); });
    } else if (val === 'bestseller') {
      sorted = visibleCards.slice().sort(function (a, b) {
        return (parseInt(b.dataset.bestseller || 0, 10) - parseInt(a.dataset.bestseller || 0, 10)) || (parseFloat(a.dataset.price) - parseFloat(b.dataset.price));
      });
    } else if (val === 'new') {
      sorted = visibleCards.slice().sort(function (a, b) {
        return (parseInt(b.dataset.new || 0, 10) - parseInt(a.dataset.new || 0, 10)) || (parseFloat(a.dataset.price) - parseFloat(b.dataset.price));
      });
    } else {
      sorted = originalOrder.filter(function (o) { return !o.el.classList.contains('hidden'); }).map(function (o) { return o.el; });
    }
    sorted.forEach(function (c) { grid.appendChild(c); });
  }

  function reset() {
    document.querySelectorAll('.filters input[type="checkbox"]').forEach(function (cb) { cb.checked = false; });
    if (priceMinInput) priceMinInput.value = priceMin;
    if (priceMaxInput) priceMaxInput.value = priceMax;
    updateRangeFill();
    if (sortSelect) sortSelect.value = sortSelect.options[0].value;
    applyFilters();
    applySort();
  }

  document.querySelectorAll('.filters input[type="checkbox"]').forEach(function (cb) {
    cb.addEventListener('change', function () { applyFilters(); applySort(); });
  });
  if (priceMinInput) {
    priceMinInput.addEventListener('input', function () { updateRangeFill(); applyFilters(); applySort(); });
  }
  if (priceMaxInput) {
    priceMaxInput.addEventListener('input', function () { updateRangeFill(); applyFilters(); applySort(); });
  }
  if (sortSelect) sortSelect.addEventListener('change', applySort);
  if (resetBtn) resetBtn.addEventListener('click', reset);

  // Met à jour les compteurs des filtres (Type, Occasion) basés sur les cards
  // présentes (pas de hardcode côté Liquid).
  (function refreshFilterCounts() {
    document.querySelectorAll('input[data-filter="format"]').forEach(function (cb) {
      var val = cb.value;
      var n = cards.filter(function (c) { return c.dataset.format === val; }).length;
      var lbl = cb.parentElement.querySelector('.filter-item__count');
      if (lbl) lbl.textContent = n;
    });
    document.querySelectorAll('input[data-filter="theme"]').forEach(function (cb) {
      var val = cb.value;
      var n = cards.filter(function (c) {
        return (c.dataset.themes || '').split(',').indexOf(val) !== -1;
      }).length;
      var lbl = cb.parentElement.querySelector('.filter-item__count');
      if (lbl) lbl.textContent = n;
    });
    var stockCb = document.querySelector('input[data-filter="stock"]');
    if (stockCb) {
      var nStock = cards.filter(function (c) { return c.dataset.stock === 'in'; }).length;
      var lbl = stockCb.parentElement.querySelector('.filter-item__count');
      if (lbl) lbl.textContent = nStock;
    }
  })();

  updateRangeFill();
  applyFilters();
})();
